import React from 'react';

class TestimonialsItem extends React.Component {
    render () {
        const { data } = this.props;
        return (
	        <div className="item-review">
		        <div className="inner-review">
			        <i className="fa fa-quote-right" />
			        <div className="review">
				        <p className="p-tag">{ data.body }</p>
			        </div>
			        <div className="user-details">
				        <strong>{ data.name }</strong><br/>
				        { data.type === 0 ? "Network Member" : data.company }
			        </div>
		        </div>
	        </div>
        )
    }
}

export default TestimonialsItem;


// WEBPACK FOOTER //
// src/client/components/site/features/testimonials/TestimonialsItem.js